import { AnimatedSection } from './AnimatedSection'
import { Button } from './Button'

export function Hero() {
  return (
    <AnimatedSection className="container mx-auto px-4 py-16 text-center">
      <h1 className="text-4xl md:text-6xl font-bold text-foreground mb-6 flex flex-col md:flex-row items-center justify-center gap-4">
        let's go here, <span className="text-primary">Soonish</span>
      </h1>
      <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
        Never forget that spot you saw. Save from TikTok, Instagram, or anywhere else to your personal map of places to visit, all in one app.
      </p>
      <div className="flex justify-center gap-4">
        <Button />
      </div>
    </AnimatedSection>
  )
} 